import * as React from 'react';

import Button, { Props as ButtonProps } from 'components/Button';
import Buttons from 'components/Buttons';

type ButtonCellInput<D> = {
  fieldForAction: keyof D;
  onClickAction: (arg0: D[keyof D]) => void;
  buttonLabel: React.ReactNode;
  buttonProps: Partial<ButtonProps>;
};

/*
  Example of how D works (mouse over type showing should work if you uncomment the next line)
  
  type DExample = ButtonCellInput<{field1: boolean, field2: string, field3: {complexObject: () => void}}>
  The actual typing resolves into:
    fieldForAction: "field1" | "field2" | "field3";
    onClickAction: (arg0: string | boolean | {
        complexObject: () => void;
    }) => void;

    which means that we have a VERY strongly typed ButtonCellInput provided that you type D correctly.
*/

export function getButtonCellGenerator<D>(input: ButtonCellInput<D>) {
  return (data: D) => {
    if (!input.buttonLabel) {
      return null;
    }

    return (
      <Button
        {...input.buttonProps}
        onClick={e => {
          e.stopPropagation();
          input.onClickAction(data[input.fieldForAction]);
        }}>
        {input.buttonLabel}
      </Button>
    );
  };
}

export function getButtonCellsGenerator<D>(input: ButtonCellInput<D>[]) {
  return (data: D) => {
    return (
      <Buttons align="left">
        {input.map<React.ReactElement>(cell => {
          return (
            <Button
              {...cell.buttonProps}
              onClick={e => {
                e.stopPropagation();
                cell.onClickAction(data[cell.fieldForAction]);
              }}>
              {cell.buttonLabel}
            </Button>
          );
        })}
      </Buttons>
    );
  };
}
